module.exports = __webpack_public_path__ + "img/pen-clip.70d116e2.svg";